import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import UserContext, { getUserDisplayName } from '../contexts/user.js';
import StateContext from '../contexts/state.js';
import useUser from '../hooks/useUser.js';
import Badge from './Badge.js';

import '../styles/userMenu.css';

const getInitials = (userContext) => {
    const source = getUserDisplayName(userContext, { includeSurname: true });
    const words = source.trim().split(/\s+/).filter(Boolean);
    const initials = words.length > 1 ?
        `${words[0][0]}${words[words.length - 1][0]}` :
        source.slice(0, 2);

    return initials.toUpperCase();
};

const UserMenu = () => {
    const { userContext } = useContext(UserContext);
    const { state } = useContext(StateContext);
    const { logout } = useUser();

    const [open, setOpen] = useState(false);

    if(!userContext.authenticated) {
        return (
            <Link className="user-menu login" to="/login">Login</Link>
        );
    }

    return (
        <div className="user-menu">
            <button
                type="button"
                className="initials"
                aria-label="Account menu"
                onClick={ () => setOpen(open => !open) }
            >
                {
                    getInitials(userContext)
                }
                { false && <Badge content={ state.actionsRequired } className="badge" /> }
            </button>

            { open && (
                <div className="panel">
                    <Link to="/user">My profile</Link>
                    <Link to="#" onClick={logout}>Log out</Link>
                </div>
            )}
        </div>
    );
};

export default UserMenu;
